module.exports = __webpack_public_path__ + "static/img/Ncs-Default.da50826.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Ncs-Default.png
// module id = 1571
// module chunks = 0